<template>
  <div :id="`collapse-punch-card-campaign-design-container-${collapseId}`" class="d-flex flex-column">
    <div class="d-inline-flex align-items-center justify-content-between">
      <h3 class="header">
        <slot name="header"></slot>
      </h3>
      <b-button v-b-toggle="`collapse-punch-card-campaign-design-${collapseId}`"
        :class="['p-0 bg-transparent border-0 shadow-none collapse-toggle', { '-collapse-open': campaignData.designVisibility[collapseId] }]" @click.self="toggleAccordion"></b-button>
    </div>
    <b-collapse :id="`collapse-punch-card-campaign-design-${collapseId}`"
      v-model="campaignData.designVisibility[collapseId]">
      <b-card no-body :class="['border-0', collapseContentClass]">
        <slot name="content"></slot>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    collapseId: {
      type: String,
      default: ""
    },
    collapseContentClass: {
      type: String,
      default: "mt-0"
    }
  },
  computed: {
    ...mapFields("punchCard", ["campaignData"])
  },
  methods: {
    toggleAccordion() {
      const closeThisIds = ["stamps", "rewards", "customize"];

      closeThisIds.splice(closeThisIds.indexOf(this.collapseId), 1);

      closeThisIds.forEach((id) => this.campaignData.designVisibility[id] = false);
    }
  }
}
</script>

<style lang="scss" scoped>
div[id^="collapse-punch-card-campaign-design-container-"] {
  border-radius: 10px;
  padding: 24px 16px;
  border: solid 1px #D8DCDE;

  .header {
    font-family: MainFontBold, sans-serif;
    font-size: 18px;
    color: #2F3941;
    margin-bottom: 0;
  }

  .collapse-toggle {
    width: 20px;
    height: 16px;
    background: transparent url('~@/assets/images/caret-down-2.svg') no-repeat center;
    transition: all 0.2s ease-in-out;
    
    &.-collapse-open {
      transform: rotate(180deg);
    }
  }
}
</style>
